module.exports = __webpack_public_path__ + "assets/alarmas.bbf37c97a766448f5672261de1a51011.png";


//////////////////
// WEBPACK FOOTER
// ./img/landingPage/alarmas.png
// module id = 885
// module chunks = 0